import { type FunctionComponent } from 'react';

import { URLS } from 'components/shared/App/constants';
import ListFilterButton from 'components/shared/ListFilterButton';

export interface PendingPayoutButtonProps {
  active: boolean;
  toggleValue: (key: string) => void;
}

const PendingPayoutButton: FunctionComponent<PendingPayoutButtonProps> =
  function ({ active, toggleValue }) {
    return (
      <ListFilterButton
        id="staff-jobs-pending-payout"
        active={active}
        label="Jobs pending payout"
        activeLabel="Jobs not pending payout"
        onClick={() => {
          toggleValue('pendingPayout');
          window.location.href =
            URLS.jobsPayoutPending + (active ? '' : `?pendingPayout=true`);
        }}
      />
    );
  };

export default PendingPayoutButton;
